import { Controller } from "@hotwired/stimulus"

// Asks for confirmation before a form is submitted, also on pages without Turbo.
//
//   <form data-controller="confirm" data-confirm-message-value="Sure?" data-action="submit->confirm#ask">
export default class extends Controller {
  static values = { message: String }

  ask(event) {
    if (!window.confirm(this.messageValue)) event.preventDefault()
  }
}
